import { Box, Grid, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import { useDispatch } from 'react-redux';
import { useState, useEffect, ChangeEvent, ChangeEventHandler } from 'react';

const useStyles = () => ({
    gridItem: { margin: 8 },
    formContainer: {
        padding: 16
    }
});

interface FormDataProps {
    formData: {
        nomeNotificador: string;
        catProfissionalNotificador: string;
        telFaxNotificador: string;
        emailNotificador: string;
        dataNotificacao: string;
    };
    handleChange: ChangeEventHandler<HTMLInputElement>;
  }
const Notificador = ({ formData, handleChange }: FormDataProps) => {
    const classes = useStyles();
    
    return (
        <Box style={classes.formContainer}>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        required
                        type="text"
                        label="Nome"
                        fullWidth
                        size="small"
                        name="nomeNotificador"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeNotificador}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Categoria profissional"
                        fullWidth
                        size="small"
                        name="catProfissionalNotificador"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.catProfissionalNotificador}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Telefone/Fax"
                        fullWidth
                        size="small"
                        name="telFaxNotificador"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.telFaxNotificador}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="email"
                        label="Email"
                        fullWidth
                        size="small"
                        name="emailNotificador"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.emailNotificador}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="date"
                        label="Data da Notificação"
                        fullWidth
                        size="small"
                        name="dataNotificacao"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataNotificacao}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default Notificador
